export { default } from 'features/store/pages/pickup-store-selector';
